/**
 * @param {{
 *   TenantService: ReturnType<import('../../services/TenantService').default>,
 * }} param0
 */
export default function tenantUseCase({ TenantService }) {
  const getAccount = () => {
    return TenantService.getAccount();
  };

  const getPayments = (tenantId) => {
    if (!tenantId) {
      return [];
    }
    return TenantService.getPayments(tenantId);
  };

  const deleteAccount = () => {
    return TenantService.deleteAccount();
  };

  const connectCustomDomain = (domain) => {
    return TenantService.connectCustomDomain(domain);
  };

  const getCustomDomainStatus = () => {
    return TenantService.getCustomDomainStatus();
  };

  const verifyCustomDomain = () => {
    return TenantService.verifyCustomDomain();
  };

  return {
    getAccount: getAccount,
    deleteAccount: deleteAccount,
    getPayments: getPayments,
    connectCustomDomain: connectCustomDomain,
    getCustomDomainStatus: getCustomDomainStatus,
    verifyCustomDomain: verifyCustomDomain,
  };
}
